import { useEffect, useState } from 'react';
import { Typewriter } from 'react-simple-typewriter';

export default function StepWithShimmer({ currentStep }) {
  const [text, setText] = useState('');

  // whenever currentStep changes, reset the typewriter
  useEffect(() => {
    setText(currentStep);
  }, [currentStep]);

  return (
    // <span
    //   className="
    //     inline-block
    //     bg-shimmer-gradient bg-200% bg-clip-text text-transparent
    //     animate-shimmer
    //   "
    // >
    //   <Typewriter
    //     words={[text]}
    //     loop={1}
    //     cursor
    //     cursorStyle="|"
    //     typeSpeed={80}
    //     deleteSpeed={50}
    //     delaySpeed={1000}
    //   />
    //   {text}
    // </span>
    // <Typewriter
    //     words={[text]}
    //     loop={1}
    //     cursor
    //     cursorStyle="|"
    //     typeSpeed={80}
    //     deleteSpeed={50}
    //     delaySpeed={250}
    //   />
    <>{text}</>
  );
} 